import { createFileRoute } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { LeadForm } from "@/components/LeadForm";

const SITE = "https://shopify-freelancer.net";
const TITLE = "Shopify Experte kontaktieren, kostenlose Ersteinschätzung";
const DESCRIPTION =
  "Shopify Freelancer anfragen: Shop-Erstellung, Anpassungen ab 110 € netto die Stunde oder Conversion-Optimierung ab 3.990 €. Antwort innerhalb von 48 Stunden.";

export const Route = createFileRoute("/kontakt")({
  component: KontaktPage,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}/kontakt` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: `${SITE}/kontakt` },
      { rel: "alternate", hrefLang: "de", href: "https://shopify-freelancer.net/kontakt" },
      { rel: "alternate", hrefLang: "en", href: "https://shopify-freelancer.net/en/contact" },
      { rel: "alternate", hrefLang: "x-default", href: "https://shopify-freelancer.net/kontakt" },
    ],
  }),
});

const EMAIL = "info@shopify-freelancer.net";

function KontaktPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <main>
        <section className="veil border-b border-border/60 py-16 md:py-20">
          <div className="mx-auto grid max-w-5xl gap-10 px-5 md:grid-cols-[1fr_1.1fr]">
            <div>
              <h1 className="text-4xl font-bold leading-tight md:text-5xl">
                Kostenlose <span className="text-signal">Ersteinschätzung</span> zu Ihrem Shopify-Projekt
              </h1>
              <p className="mt-5 text-muted-foreground">
                Neuer Shop, Anpassung am Theme oder mehr Umsatz aus Ihrem Traffic: Sie
                erhalten innerhalb von 48 Stunden eine kurze Einschätzung, den empfohlenen
                nächsten Schritt und, soweit anhand Ihrer Angaben möglich, einen groben
                Kostenrahmen. Kostenlos und unverbindlich.
              </p>
              <p className="mt-4 leading-relaxed text-foreground">
                Danach wissen Sie, ob eine kleine Anpassung reicht, ein Festpreis sinnvoll ist
                oder Sie sich das Vorhaben sparen können.
              </p>
              <ul className="mt-6 grid gap-2 text-sm text-muted-foreground">
                <li>Anpassungen und Entwicklung: 110 € netto die Stunde</li>
                <li>Conversion-Optimierung: Festpreis ab 3.990 € netto</li>
                <li>Shop-Erstellung: Festpreis nach Umfang</li>
              </ul>
              <div className="mt-6 border-l-2 border-primary pl-4">
                <p className="text-sm font-semibold text-foreground">Erfahrung aus echten Shops</p>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                  Unter anderem für Lunu, kremka, MASKABEL, Snyder Golf und Logo-Matten.
                  Sie sprechen direkt mit Nicolai Schnepf, der die Arbeit auch umsetzt.
                </p>
              </div>
              <a
                href={`mailto:${EMAIL}`}
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary"
              >
                {EMAIL}
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>

            <LeadForm
              source="kontakt"
              compact={false}
              showServices
              tracking="google"
              headline="Kostenlose Einschätzung erhalten"
            />
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
